<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="imei-input-modal"
        ok-disabled
        ref="imei-input-modal"
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
              {{$t('bp.ImeiInputModal.title')}}
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">
            <div class="alert alert-info text-sm" v-if="carrierDetails.hasCallOutCharge">
                <div class="alert-content">{{$t('bp.BookingComplete.imei.info.p1')}} <strong><span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ carrierDetails.callOutCharge }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span> {{$t('bp.BookingComplete.imei.info.p2')}}</strong>. {{$t('bp.BookingComplete.imei.info.p3')}}</div>
            </div>
            <div class="form-group" :class="{ 'has-error' : errors[0] }">
                <label>{{$t('bp.ImeiInputModal.ImeiLabel')}}</label>
                <input type="text" class="form-control" placeholder="IMEI Number" v-model="imei" />
                <p class="help-block text-danger" v-if="errors[0]">* {{ errors[0] }}</p>
            </div>
            <button class="btn btn-outline-secondary btn-block" v-b-toggle.imei-instructions>
                <i class="fa fa-info-circle mr-1"></i> {{$t('bp.ImeiModal.title')}}
            </button>
            <b-collapse id="imei-instructions">
                <p class="text-sm mt-3">
                  {{$t('bp.ImeiModal.text.p1')}}
                </p>
                <ol class="text-sm">
                    <li>
                        <strong>{{$t('bp.ImeiModal.text.list.item1.p1')}}</strong> {{$t('bp.ImeiModal.text.list.item1.p2')}} <pre class="d-inline">*#06#</pre> {{$t('bp.ImeiModal.text.list.item1.p3')}}
                    </li>
                    <li>
                        <div>
                            <strong>{{$t('bp.ImeiModal.text.list.item2.p1')}}</strong> {{$t('bp.ImeiModal.text.list.item2.p2')}} <pre class="d-inline">{{$t('bp.ImeiModal.text.list.item2.p3')}}</pre>.
                        </div>
                        <div>
                            <strong>{{$t('bp.ImeiModal.text.list.item3.p1')}}</strong> {{$t('bp.ImeiModal.text.list.item3.p2')}} <pre class="d-inline">{{$t('bp.ImeiModal.text.list.item3.p3')}}</pre>.
                        </div>
                    </li>
                    <li>
                        <strong>{{$t('bp.ImeiModal.text.list.item4.p1')}}</strong> {{$t('bp.ImeiModal.text.list.item4.p2')}}
                    </li>
                </ol>
            </b-collapse>
            <!-- Footer buttons -->
            <template v-if="!saving">
                <button class="btn btn-success btn-block mt-4 btn-lg" @click="saveImei()">{{$t('bp.ImeiInputModal.addButton')}}</button>
                <button class="btn btn-link btn-block" @click="$bvModal.hide('imei-input-modal')">{{$t('bp.ImeiInputModal.cancelButton')}}</button>
            </template>
            <button v-else class="btn btn-success btn-lg btn-block mt-4 disabled"><animated-loading class="mr-2" size="sm"></animated-loading>{{$t('bp.ImeiInputModal.updateButtonDisabled')}}</button>
        </div>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        props:["deviceId", "order"],

        data() {
            return {
                errors: [],
                imei: "",
                saving: false
            }
        },

        computed: {
            ...mapGetters([
                'carrierDetails',
                'currencySymbol',
                'countryCodeSetting'
            ])
        },

        methods: {
            ...mapActions([
                "displayToast",
                "setOrderDeviceImei"
            ]),

            saveImei() {
                this.errors = [];
                this.saving = true;

                this.setOrderDeviceImei({
                    deviceId: this.deviceId,
                    imei: this.imei,
                    order: this.order
                }).then(() => {
                    this.$bvModal.hide('imei-input-modal');
                    this.saving = false;
                    this.displayToast({text: this.$t('bp.Toast.imei.added'), type: 'success'});
                    this.$emit("imei-added");
                }).catch(errors => {
                    this.saving = false;
                    if (errors.response.data.messages.imei) {
                        this.errors = errors.response.data.messages.imei;
                    } else {
                        this.errors = errors.response.data.messages;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>